export const BRANCHES_LIST = "PLATFORMS_PORTAL_BRANCHES_LIST";
export const BRANCHES_CREATE = "PLATFORMS_PORTAL_BRANCHES_CREATE";
export const BRANCHES_UPDATE = "PLATFORMS_PORTAL_BRANCHES_UPDATE";
export const BRANCHES_DELETE = "PLATFORMS_PORTAL_BRANCHES_DELETE";
export const BRANCHES_SHOW = "PLATFORMS_PORTAL_BRANCHES_SHOW";
